<template>
    <v-container class="py-5" style="height: 202px">
        <v-card class="">
            <v-row class="px-3 pt-2">
                <v-col class="font14 pl-2 pr-0 py-1 d-flex text-center flex-column align-start justify-center">
                    <span style="color: #808080">
                        {{ $t('betDialogConfirm.orderPlaced') }}
                    </span>
                    <span class="">#{{ orderPlaced.internal_id }}</span>
                </v-col>
                <v-col class="font14 px-0 py-1 d-flex text-center flex-column align-start justify-center">
                    <span style="color: #808080">
                        {{ $t('betDialogConfirm.stakeRequested') }}
                    </span>
                    <span class="">{{ utils.getCurrencySymbol(user.currency) }}{{ orderPlaced.stake }}</span>
                </v-col>
                <v-col class="font14 px-0 py-1 d-flex text-center flex-column align-start justify-center">
                    <span style="color: #808080">
                        {{ $t('betDialogConfirm.stakeDone') }}
                    </span>
                    <span
                        v-if="!isEmpty(orderPlaced.stats)"
                        :class="
                            orderPlaced.stats.bet_waiting_count > 0 ? 'orangeText bold' : orderPlaced.stats.sum_bet_stake > 0 ? 'greenText bold' : 'redText'
                        "
                    >
                        {{ utils.getCurrencySymbol(user.currency) }}{{ orderPlaced.stats.sum_bet_stake }} ({{ orderPlaced.stats.fill_percent }}%)
                    </span>
                    <span v-else>&nbsp;</span>
                </v-col>
            </v-row>

            <v-row class="px-3">
                <v-col class="py-5 font14 text-center bold px-1" v-html="orderStatusInfo"></v-col>
                <v-progress-linear :color="progressColor" :indeterminate="progressIndeterminate" class="mx-2"></v-progress-linear>
            </v-row>
            <v-row class="px-3" style="height: 70px">
                <v-col cols="3"></v-col>
                <v-col class="text-center d-flex flex-column justify-center align-center">
                    <v-btn
                        tag="a"
                        v-if="
                            orderPlaced.status_id === $const.ORDER_STATUS_OPEN_ID &&
                            ((orderPlaced.status_id === $const.ORDER_STATUS_OPEN_ID && orderPlaced.timeout === null) || orderPlaced.diffSec)
                        "
                        dark
                        color="red"
                        @click="showCloseOrderConfirm()"
                        style="color: white"
                        elevation="0"
                    >
                        {{ $t('action.cancelOrder') }}
                    </v-btn>
                    <AppDialogClose
                        ref="orderClose"
                        @deleteItem="closeOrder"
                        @cancel="closeOrderConfirm"
                        confirmButtoncolor="tbGreen"
                        :confirmText="$t('order.closeOrderText')"
                    ></AppDialogClose>
                </v-col>
                <v-col cols="3" class="px-0 py-1 px-1 d-flex text-center flex-column align-start justify-center pl-2">
                    <div
                        v-if="
                            orderPlaced.status_id === $const.ORDER_STATUS_OPEN_ID &&
                            ((orderPlaced.status_id === $const.ORDER_STATUS_OPEN_ID && orderPlaced.timeout === null) || orderPlaced.diffSec)
                        "
                        class="timeout d-flex flex-column justify-center align-center"
                    >
                        <span v-if="orderPlaced.status_id === $const.ORDER_STATUS_OPEN_ID && orderPlaced.diffSec > 0" class="orangeText bold">
                            <AppCountDown :fromTime="orderPlaced.created_at" :timeout="orderPlaced.timeout" v-model="orderPlaced.diffSec"></AppCountDown>
                        </span>
                        <span v-else-if="orderPlaced.status_id === $const.ORDER_STATUS_OPEN_ID && orderPlaced.timeout === null" class="orangeText">
                            <span>{{ $t('panel.kickOff') }}</span>
                        </span>
                        <!--                    <span v-else-if="orderPlaced.status_id === $const.ORDER_STATUS_CLOSING_ID" class="font10 redText">-->
                        <!--                        {{ $t('panel.closing') }}-->
                        <!--                    </span>-->
                        <span v-else>&nbsp;</span>
                    </div>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<style scoped>
    .timeout {
        border: solid 2px orange;
        border-radius: 4px;
        //padding: 0 15px 0 15px;
        width: 85px;
        height: 36px;
    }
</style>
<script>
    import AppCountDown from 'Pages/core/countDown/AppCountDown.vue';
    import AppDialogClose from 'Pages/core/confirm/AppDialogConfirm.vue';
    import utils from 'Helpers/utils';

    export default {
        name: 'BetDialogBetInfo',
        components: { AppDialogClose, AppCountDown },
        props: {
            orderPlaced: {
                default: undefined,
                type: Object,
            },
        },

        methods: {
            showCloseOrderConfirm() {
                this.$refs.orderClose.open();
            },
            closeOrderConfirm(success) {
                success();
            },
            closeOrder(success) {
                let params = {
                    rows: [
                        {
                            id: this.orderPlaced.id,
                            status_id: this.$const.ORDER_STATUS_CLOSING_ID,
                        },
                    ],
                };
                this.$store.dispatch('OrderModule/update', params).then(() => {
                    success();
                });
            },
            isEmpty(item) {
                return _.isEmpty(item);
            },
        },

        computed: {
            orderStatusInfo() {
                let orderStatusInfo = '';
                let orderBettingStageInfo = ':';
                let color = 'green';

                if (this.orderPlaced.status_id === this.$const.ORDER_STATUS_OPEN_ID || this.orderPlaced.status_id === this.$const.ORDER_STATUS_CLOSING_ID) {
                    if (_.isEmpty(this.orderPlaced.stats)) {
                        color = 'orange';
                        orderStatusInfo = this.$t('betDialogBetInfo.orderSubmitted');
                        orderBettingStageInfo = '';
                    } else if (this.orderPlaced.stats.bet_waiting_count > 0) {
                        color = 'orange';
                        orderStatusInfo = this.$t('betDialogBetInfo.betsDone', {
                            odds: utils.formatOdds(this.orderPlaced.stats.odds_waiting),
                            currency: utils.getCurrencySymbol(this.user.currency),
                            stake: this.orderPlaced.stats.sum_bet_waiting_stake,
                        });
                        orderBettingStageInfo += ' ' + this.$t('betDialogBetInfo.waiting');
                    } else if (this.orderPlaced.stats.active_betting_count > 0) {
                        orderStatusInfo = this.$t('betDialogBetInfo.priceAvailable');
                        orderBettingStageInfo += ' ' + this.$t('betDialogBetInfo.attempting');
                    } else {
                        color = 'red';
                        orderStatusInfo = this.$t('betDialogBetInfo.priceNotAvailable');
                        orderBettingStageInfo += ' ' + this.$t('betDialogBetInfo.lookingForPrice') + ' @' + utils.formatOdds(this.orderPlaced.odds);
                    }

                    orderStatusInfo = '<span class="' + color + 'Text">' + orderStatusInfo + '</span>';
                    orderBettingStageInfo = '<span class="orangeText">' + orderBettingStageInfo + '</span>';
                } else if (this.orderPlaced.status_id === this.$const.ORDER_STATUS_CLOSED_ID) {
                    orderStatusInfo = this.$t('betDialogBetInfo.orderClosed');

                    if (this.orderPlaced.close_reason_id === this.$const.ORDER_CLOSE_REASON_MANUALLY_CLOSED) {
                        orderStatusInfo += ' (' + this.$t('betDialogBetInfo.manually') + ')';
                    } else if (this.orderPlaced.close_reason_id === this.$const.ORDER_CLOSE_REASON_SCORE_CHANGED) {
                        orderStatusInfo += ' (' + this.$t('betDialogBetInfo.scoreChanged') + ')';
                    } else if (this.orderPlaced.close_reason_id === this.$const.ORDER_CLOSE_REASON_TIMED_OUT) {
                        orderStatusInfo += ' (' + this.$t('betDialogBetInfo.timedOut') + ')';
                    }

                    if (this.orderPlaced.stats.bet_count > 0) {
                        orderBettingStageInfo +=
                            ' ' +
                            this.$tc('order.betDone', this.orderPlaced.stats.bet_count - 1, {
                                count: this.orderPlaced.stats.bet_count,
                            }) +
                            ' @' +
                            utils.formatOdds(this.orderPlaced.stats.odds);
                    } else {
                        color = 'red';
                        orderBettingStageInfo += ' ' + this.$t('betDialogBetInfo.noBetsDone');
                    }

                    orderStatusInfo = '<span class="' + color + 'Text" style="margin-right: -4px;">' + orderStatusInfo + '</span>';
                    orderBettingStageInfo = '<span class="' + color + 'Text">' + orderBettingStageInfo + '</span>';
                }

                return orderStatusInfo + ' ' + orderBettingStageInfo;
            },
            progressColor() {
                let color = 'green';

                if (
                    _.isEmpty(this.orderPlaced.stats) ||
                    ((this.orderPlaced.status_id === this.$const.ORDER_STATUS_OPEN_ID || this.orderPlaced.status_id === this.$const.ORDER_STATUS_CLOSING_ID) &&
                        this.orderPlaced.stats.bet_waiting_count > 0)
                ) {
                    color = 'orange';
                } else if (this.orderPlaced.status_id === this.$const.ORDER_STATUS_CLOSED_ID && this.orderPlaced.stats.bet_count === 0) {
                    color = 'red';
                }

                return color;
            },
            progressIndeterminate() {
                return this.orderPlaced.status_id === this.$const.ORDER_STATUS_OPEN_ID;
            },
            user() {
                return this.$store.getters['UserModule/getUser'];
            },
        },
    };
</script>
